import { useState, useEffect } from "react";
import axios from "axios";
import { Col, Row, List } from "antd";
import DashboardCard from "../components/dashboard/dashboardCard";
import DashboardList from "../components/dashboard/dashboardList";
import WeeklyUserEventsChart from "../components/dashboard/weeklyUserEventsChart";
import RegisteredUsersChart from "../components/dashboard/registeredUsersChart";

function Home() {
  const [dashboard, setDashboard] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("http://78.186.196.90:8091/dashboard");
      setDashboard(response.data);
    };
    fetchData();
  }, []);

  return (
    <>
      <main>
        <header>
          <h1>Dashboard</h1>
        </header>
        <section>
          {dashboard && dashboard.infos && (
            <List
              className="infos"
              grid={{
                gutter: 16,
                xs: 1,
                sm: 2,
                md: 4,
                lg: 4,
                xl: 4,
                xxl: 4,
              }}
              dataSource={dashboard.infos}
              renderItem={(item) => (
                <List.Item>
                  <DashboardCard
                    icon={item.icon}
                    colors={item.colors}
                    title={item.title}
                    value={item.value}
                  />
                </List.Item>
              )}
            />
          )}
        </section>
        <section className="charts">
          <div className="chart">
            {dashboard && dashboard.charts && (
              <RegisteredUsersChart data={dashboard.charts.registeredUsers} />
            )}
          </div>
          <div className="chart">
            {dashboard && dashboard.charts && (
              <WeeklyUserEventsChart data={dashboard.charts.weeklyUsage} />
            )}
          </div>
        </section>
        <section className="lists">
          {dashboard && dashboard.scenarios && (
            <Row gutter={20}>
              <Col flex={3}>
                <DashboardList
                  data={dashboard.scenarios}
                  title="Scenarios"
                  style={{ grow: 3 }}
                />
              </Col>
              <Col flex={2}>
                <DashboardList
                  data={dashboard.users}
                  title="Top Rated Users"
                  style={{ grow: 1 }}
                />
              </Col>
            </Row>
          )}
        </section>
      </main>
    </>
  );
}

export default Home;
